<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
          <el-select
            v-model="value"
            placeholder="切换方案"
            @change="selectOption"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <!-- 数据安全解决方案 -->
    <div v-show="select1">
      <div class="introduce">
        <p class="sub_title">
          政策和法规驱动
        </p>
        <div class="content_A pic">
          <img
            src="@/assets/solution/dataSecurity/policy.png"
            alt=""
          >
        </div>
      </div>

      <div class="introduce bg">
        <p
          v-show="select1"
          class="sub_title"
        >
          数据安全能力
        </p>
        <div class="content_A pic">
          <img
            src="@/assets/solution/dataSecurity/dataSecurity.png"
            alt=""
          >
        </div>
      </div>

      <div class="introduce">
        <p class="sub_title">
          数据安全建设规划
        </p>
        <div class="content_A plans">
          <div
            v-for="item in select1_plan"
            :key="item.id"
            class="plan"
          >
            <div class="plan_pic">
              <img
                :src="item.pic"
                alt=""
              >
            </div>

            <div class="plan_text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>

      <div class="introduce bg">
        <p class="sub_title">
          整体设计方案说明
        </p>
        <div class="content_A">
          以“零信任”为安全理念安全防护建设覆盖数据的整个生命周期包含数据采集、容灾备份、数据存储安全、勒索病毒防御、数据安全内控、数据外部访问安全、数据流动安全、数据库智能化运维，
          每一个阶段都以不同保护手段建立一个围绕数据生命周期的纵深防御体系。
        </div>
        <div class="classify_title">
          <div class="classify">
            数据发现分类分级
          </div>
        </div>
        <div class="classify_lists">
          <div class="classify_left">
            <div
              v-for="item in classify_lists"
              :key="item.id"
              class="classify_list"
            >
              <div class="list_number">
                {{ item.number }}
              </div>
              <div class="list_text">
                {{ item.text }}
              </div>
            </div>
          </div>

          <div class="classify_pic">
            <img
              src="@/assets/solution/dataSecurity/pic661.png"
              alt=""
            >
            <div class="circle">
              敏感数据<br>防护
            </div>
            <div class="list_number">
              7: 安全内控
            </div>
            <div class="list_text">
              以数据库事前监控、事中问题定位、以数据库资源分析，数据库SQL注入、漏洞安全基线防护
            </div>
          </div>
          <div class="classify_right">
            <div
              v-for="item in classify_right"
              :key="item.id"
              class="classify_list"
            >
              <div class="list_number">
                {{ item.number }}
              </div>
              <div class="list_text">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 非结构化数据主要传播途径 -->
    <div v-show="select2">
      <div class="introduce">
        <p class="sub_title">
          非结构化数据主要传播途径
        </p>
        <div class="ways">
          <div
            v-for="item in ways"
            :key="item.id"
            class="way"
          >
            <div
              v-if="!item.hasImg"
              class="left_way"
            >
              {{ item.title }}
            </div>
            <div
              v-if="!item.hasImg"
              class="right_way"
            >
              {{ item.text }}
            </div>
            <div
              v-if="item.hasImg"
              class="hasImg"
            >
              <img
                src="@/assets/solution/constructor/circle.png"
                alt=""
              >
              <div class="imgContent">
                传&nbsp;播途&nbsp;径
              </div>
            </div>
          </div>
        </div>
        <div class="way2">
          <div class="left_way">
            移动存储
          </div>
          <div class="right_way">
            移动存储类介质主要是U盘、移动硬盘等设备，该类设备由于具备拷贝数据、存储数据的功能，非法泄密人员可以很轻松的将重要数据拷贝进设备中，然后将其带出单位，由此引发单位内部数据的外泄。
          </div>
        </div>
      </div>

      <div class="introduce background">
        <p class="sub_title">
          非结构化数据防泄密解决方案
        </p>

        <div class="solutions">
          <div
            v-for="item in solutions"
            :key="item.id"
            class="solution"
          >
            <div class="solution_title">
              {{ item.title }}
            </div>
            <div class="solution_text">
              {{ item.text }}
            </div>
            <span class="index_Number">
              {{ item.number }}
            </span>
          </div>
        </div>
      </div>

      <div class="introduce ">
        <p class="sub_title">
          方案价值
        </p>
        <Lists :values="values" />
      </div>
    </div>

    <div v-show="select3">
      <div class="introduce">
        <p class="sub_title">
          数据安全风险评估思路
        </p>
        <div class="content_A">
          <div class="content_s">
            <div
              v-for="item in analyses"
              :key="item.id"
              class="listS"
            >
              <div class="top_list">
                <div class="number">
                  {{ item.id }}
                </div>
                <div class="number_title">
                  {{ item.title }}
                </div>
              </div>

              <div class="list">
                <div
                  v-for="text in item.lists"
                  :key="text"
                  class="listText"
                >
                  {{ text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="introduce background">
        <p class="sub_title">
          评估手段
        </p>
        <div class="content_A">
          <div class="measures">
            <div
              v-for="item in measures"
              :key="item.id"
              class="measure"
            >
              <div class="title">
                {{ item.title }}
              </div>
              <div class="text">
                {{ item.text }}
              </div>
              <div class="round">
                {{ item.num }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="introduce">
        <p class="sub_title">
          确定评估内容
        </p>
        <div class="content_A">
          结合评估目标、范围、依据，针对被评估方的实际情况，确定被评估方适用的评估内容。
        </div>
        <div class="content_A ensure">
          <img
            src="@/assets/solution/dataSecurity/6e8cb11ac4d27847d6241a86713bb91a.png"
            alt=""
          >
          <div class="purple_text">
            <div
              v-for="item in valueContent"
              :key="item"
              class="step"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Lists from '@/views/solution/components/lists.vue'

export default {
  name: 'Security',
  components: {
    Lists
  },
  data() {
    return {
      title: '数据安全解决方案',
      subtitle: '信息安全等级保护是指对国家秘密信息、法人和其他组织及公民的专有信息以及公开信息和存储、传输、处理这些信息的信息系统分等级实行安全保护，对信息系统中使用的信息安全产品实行按等级管理，对信息系统中发生的信息安全事件分等级响应、处置。',
      options: [
        {
          value: '1',
          label: '数据安全解决方案'
        },
        {
          value: '2',
          label: '非结构化数据安全解决方案'
        },
        {
          value: '3',
          label: '数据安全评估解决方案'
        }
      ],
      value: '',
      select1: true,
      select2: false,
      select3: false,
      select1_plan: [
        {
          id: 1,
          pic: require('@/assets/solution/dataSecurity/plan1.png'),
          text: '数据权限设计'
        },
        {
          id: 2,
          pic: require('@/assets/solution/dataSecurity/plan2.png'),
          text: '数据安全管理建设规划'
        },
        {
          id: 3,
          pic: require('@/assets/solution/dataSecurity/plan3.png'),
          text: '数据安全技术建设规划'
        }
      ],
      classify_lists: [
        {
          id: 1,
          number: '1: 容灾备份',
          text: '数据库双活架构，其他系统采用实时备份'
        },
        {
          id: 2,
          number: '2: 存储安全',
          text: '以身份鉴别、数据落盘加密、应用透明访问'
        },
        {
          id: 3,
          number: '3: 勒索病毒发防御',
          text: '采用零信任白名单防御未知勒索病毒'
        }
      ],
      classify_right: [
        {
          id: 4,
          number: '4: 数据库智能化运维',
          text: '以数据库事前监控、事中问题定位、事后故障处理，闭环式智能化运维'
        },
        {
          id: 5,
          number: '5: 流动安全',
          text: '对敏感数据流动过程实施脱敏'
        },
        {
          id: 6,
          number: '6: 外部安全',
          text: '以数据库事前监控、事中问题定位、以数据内部管控、身份鉴别、访问控制及运维端动态脱敏等技术为主'
        }
      ],
      solutions: [
        {
          id: 1,
          title: '网络外发审计管控',
          text: '部署上网行为管理设备来进行网络访问情况的审计以及过滤，上网行为管理设备可以对用户的各类操作进行管控，支持对终端的应用控制、内容审计与过滤，其中应用控制可以对即时聊天工具、网盘等，内容审计与过滤则是主要对电子邮件收发内容、论坛发帖情况、网页搜索内容等进行审计与过滤。',
          number: '01'
        },
        {
          id: 2,
          title: '文件内容审计过滤',
          text: '部署终端安全管理系统可以对终端设备上文件的各种操作行为进行管控，详细记录文件的整个操作流程。同时可以扫描并发现电脑上的敏感信息分布和不当存储，进行关键词预警，一旦有违规内容，立刻自动采取警告、隔离、甚至阻断等保护动作。针对终端文件的流转进行全面的审计，包含对终端上文件的外发和读写进行审计，实现文档的全流程跟踪和防护，便于事后进行追溯。',
          number: '02'
        },
        {
          id: 3,
          title: '移动存储介质管理',
          text: '终端安全管理系统能够实现对移动存储设备的灵活管控，包括移动存储介质的身份注册、网内终端授权管理、移动介质挂失管理、外出管理和终端设备例外等功能。给予不同的移动存储介质相应的授权范围和密级，同时支持设备状态的追踪与管理。',
          number: '03'
        },
        {
          id: 4,
          title: '屏幕水印技术',
          text: '针对屏幕水印可以将水印文字、显示计算机名、显示用户名、IP地址、MAC地址等数据以半透明的方式呈现在屏幕上。但是对以拍照等方式泄露重要数据形成有效的震慑，直接降低了以拍照方式泄露重要数据的风险。',
          number: '04'
        }
      ],
      values: [
        {
          id: 1,
          title: '协同联动，全面防范文件泄密',
          src: require('@/assets/solution/government/waiguanzidingyi.png'),
          content: '通过联动对终端进行全方位的管控，达到更为全面的互联网访问审计、文件管控，全面防范文件泄密。 '
        },
        {
          id: 2,
          title: '精细化审计网络访问情况',
          src: require('@/assets/solution/government/keshihuaguanli.png'),
          content: '上网行为管理系统提供对通过电子邮件、即时通讯、论坛发帖等途径的外发信息进行监控审计，对违反国家法律、危害社会安全的内容进行过滤，净化网络，减少病毒进入局域网的几率，降低法律风险，创造文明健康的上网环境'
        },
        {
          id: 3,
          title: '移动存储介质安全管理',
          src: require('@/assets/solution/government/gongdanchuli.png'),
          content: '移动存储介质管理针对U盘、移动硬盘等进行安全管控，给予不同的移动存储介质相应的授权范围和密级，同时可以针对设备状态进行追踪与管理。'
        },
        {
          id: 4,
          title: '终端设备安全防护',
          src: require('@/assets/solution/government/chixushengji.png'),
          content: '提供终端杀毒、补丁管理、主机防火墙功能、终端流量管理等安全管理功能。'
        }
      ],
      ways: [
        {
          id: 1,
          title: '应用转发',
          text: '邮件、即时聊天工具、WEB浏览器上传、网盘等，这些应用也极易成为数据泄密的“重灾区”，根据以往的泄密事件来看，大多数泄密的数据都是通过这类应用转发出去的。'
        },
        {
          id: 2,
          hasImg: true
        },
        {
          id: 3,
          title: '屏幕拍照 录屏传播',
          text: '可以通过手机、相机等具备拍摄功能的设备，对屏幕拍照或拍摄视频，将敏感涉密文件记录下来，带出单位后进行后续的传播，从而造成数据外露'
        }

      ],
      analyses: [
        {
          id: 1,
          title: '信息调研',
          lists: [
            '数据处理者',
            '业务和信息系统',
            '数据资产',
            '数据处理活动安',
            '全防护措施'
          ]
        },
        {
          id: 2,
          title: '风险评估',
          lists: [
            '数据安全管理',
            '数据处理活动安全',
            '数据安全技术',
            '个人信息保护'
          ]
        },
        {
          id: 3,
          title: '综合分析',
          lists: [
            '国家安全',
            '公共利益',
            '行业、组织或者',
            '个人合法权益'
          ]
        },
        {
          id: 4,
          title: '评估结果',
          lists: [
            '风险问题清单',
            '风险评估报告'
          ]

        }

      ],
      measures: [
        {
          id: 1,
          title: '人员访谈',
          text: '对相关人员进行访谈，核查制度规章、防护措施、安全责任落实情况',
          num: '1'
        },
        {
          id: 2,
          title: '文档查验',
          text: '查验安全管理制度、风险评估报告、等保测评报告等有关材料及制度落实情况的证明材料',
          num: '2'
        },
        {
          id: 3,
          title: '安全核查',
          text: '核查网络环境、数据库和大数据平台等相关系统和设备安全策略、配置、防护措施情况',
          num: '3'
        }, {
          id: 4,
          title: '技术测试',
          text: '应用技术工具、渗透测试等手段查看数据资产情况、检测防护措施有效性',
          num: '4'
        }

      ],
      valueContent: [
        'A）数据处理者应针对数据处理活动、数据安全管理、数据安全技术等方面进行风险评估；',
        'B）涉及处理个人信息的，应在 A）的基础上，对个人信息保护开展风险评估。',
        '开展评估工作过程中，可依据任务要求、评估重点、监管需要等，进一步完善评估内容。'
      ]
    }
  },
  methods: {
    selectOption() {
      if (this.value === '1') {
        this.title = '结构化数据安全解决方案',
        this.subtitle = '信息安全等级保护是指对国家秘密信息、法人和其他组织及公民的专有信息以及公开信息和存储、传输、处理这些信息的信息系统分等级实行安全保护，对信息系统中使用的信息安全产品实行按等级管理，对信息系统中发生的信息安全事件分等级响应、处置。',
        this.select1 = true,
        this.select2 = !true,
        this.select3 = !true
      } else if (this.value === '2') {
        this.title = '非结构化数据安全解决方案',
        this.subtitle = '非结构化数据是指数据结构不规则或不完整，没有预定义的数据模型，不方便用数据库二维逻辑表来表现的数据。包括所有格式的办公文档、文本、图片、XML, HTML、各类报表、图像和音频/视频信息等等。在IT领域有一条著名的理论，那就是“二八原则”，其主要讲的是结构化数据占20%，非结构化数据占80%。由此可见，这是一个非结构化数据的时代，文件数据、对象数据和流数据构成了非结构化数据的主体，也是实施安全保护的重点对象和目标。',
        this.select1 = !true,
        this.select2 = true,
        this.select3 = !true
      } else if (this.value === '3') {
        this.title = '数据安全评估方案',
        this.subtitle = '网络数据安全风险评估坚持预防为主、主动发现、积极防范，对数据处理者数据安全保护和数据处理活动进行风险评估，旨在掌握数据安全总体状况，发现数据安全隐患，提出数据安全管理和技术防护措施建议，提升数据安全防攻击、防破坏、防窃取、防泄露、防滥用能力。',
        this.select1 = false,
        this.select2 = false,
        this.select3 = true
      }
    }
  }

}

</script>

<style lang="less" scoped>
.banner {
  width: 100wh;
  height: 550px;

  img {
    width: 100%;
    height: 100%;
  }

  .banner_Title {
    position: absolute;
    top: 15%;
    left: 15%;
    width: 80%;

    .title {
      width: 85%;
      font-size: 54px;
      color: #ffffff;
      font-weight: bold;
    }

    .subtitle {
      width: 80%;
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 40px;
    }

  }
}

.pic {
  display: flex;
  justify-content: center;

  img {
    width: 100%;
  }
}

.bg {
  background: #FAFBFF;
  padding: 73px 0 89px;
}

.plans {
  display: flex;
  justify-content: space-between;
}

.plan {
  width: 32%;
  background: #EEF2FC;

  .plan_pic {
    height: 195px;
    display: flex;
    justify-content: center;
    margin: 100px auto;

    img {
      height: 100%;

    }
  }

  .plan_text {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 110px;
  }

}

.classify_title {
  display: flex;
  justify-content: center;
  width: 70%;
  margin: 0 auto;

  .classify {
    width: 301px;
    height: 65px;
    background: #EEF2FC;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: center;
    line-height: 65px;
  }
}

.classify_lists {
  width: 70%;
  margin: 40px auto;
  display: flex;
  justify-content: space-between;
  // margin-top: 40px;

  .list_number {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin-bottom: 15px;
  }

  .list_text {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }

  .classify_left {
    width: 32%;

    .classify_list {
      height: 150px;
    }
  }

  .classify_pic {
    width: 32%;
    position: relative;

    img {
      width: 98%;
      margin-bottom: 75px;
    }

    .circle {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #666666;
      position: absolute;
      left: calc(50% - 60px);
      top: 160px;
      text-align: center;
    }
  }

  .classify_right {
    width: 32%;

    .classify_list {
      height: 150px;
    }
  }

}

.ways {
  width: 70%;
  margin: 0 auto;
  height: 500px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .way {
    display: flex;

    &:nth-child(3) {
      >.left_way {
        padding: 9px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #57ACFE;

        &::after {
          content: '、';
          line-height: 14px;
        }
      }

      >.right_way {
        background: #E8F7FE;
      }
    }
  }

  img {
    width: 80%;
  }

  .hasImg {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    position: relative;

    .imgContent {
      position: absolute;
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      width: 90px;
      top: 70px;

    }
  }

  .left_way {
    word-wrap: break-word;
    width: 67px;
    height: 196px;
    background: #929AD3;
    border-radius: 10px 0px 0px 10px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    box-sizing: border-box;
    padding: 26px;
    display: flex;
    flex-direction: column;

  }

  .right_way {
    width: 357px;
    height: 196px;
    background: #F4F6F9;
    border-radius: 10px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    box-sizing: border-box;
    padding: 20px 30px;

  }
}

.way2 {
  display: flex;
  width: 70%;
  margin: 0 auto 100px;
  justify-content: center;

  .left_way {
    width: 67px;
    height: 196px;
    background: #3879F6;
    border-radius: 10px 0px 0px 10px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    box-sizing: border-box;
    padding: 26px;
    display: flex;
    flex-direction: column;
  }

  .right_way {
    width: 645px;
    height: 196px;
    background: #EBF2FE;
    border-radius: 10px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    box-sizing: border-box;
    padding: 20px 30px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }
}

.solutions {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding-top: 80px;

  >.solution {
    width: 49%;
    height: 290px;
    background: #FFFFFF;
    border-radius: 0px 40px 0px 0px;
    box-shadow: 0 0 10px 5px #D7EDFF;
    position: relative;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    margin-bottom: 80px;

    >.solution_title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #3879F6;
      line-height: 40px;
      padding: 0 30px;

    }

    >.solution_text {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 35px;
      padding: 0 30px;
    }

    .index_Number {
      font-size: 90px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #D2E1FC;
      line-height: 40px;
      position: absolute;
      top: -20px;
      right: -21px;
      z-index: 1;
    }
  }

}

.content_s {
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .listS {
    width: 24%;
    height: 480px;
    border-radius: 30px;
    background: rgba(233, 239, 253, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    &:nth-child(4) {

      .listText {
        margin-bottom: 30px;
        text-align: center;
        color: #4559E9;

        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 82px;
          background: #EAEFFC;
          border-radius: 50%;
          margin-top: -61px;
          color: #4559E9;
        }
      }
    }

  }

  .top_list {
    width: 218px;
    height: 91px;
    background: #83A8F0;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .number {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 40px;
    }

    .number_title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 40px;
    }

  }

  .list {
    width: 218px;
    height: 310px;
    background: #83A8F0;
    border-radius: 30px;

    .listText {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      padding: 0 29px;

      &:nth-child(1) {
        padding-top: 60px;
      }

      .round {
        width: 171px;
        height: 82px;
        background: #EAEFFC;
        border-radius: 50%;
      }
    }

  }

}

.measures {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .measure {
    width: 24%;
    height: 700px;
    background: #E9EFFD;
    position: relative;
    border-radius: 30px 30px 150px 150px;

    .title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      text-align: center;
      margin: 80px 0 90px;
    }

    .text {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      padding: 0 50px;
      text-align-last: center;
    }

    .round {
      width: 250px;
      height: 250px;
      border-radius: 50%;
      font-size: 48px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      text-align: center;
      line-height: 250px;
      position: absolute;
      bottom: 22px;
      left: calc(50% - 125px);
      background: #B2C9FB;
    }

    &:nth-child(2n) {
      background: #ADC9FF;

      .round {
        background-color: #fff;
      }

    }
  }
}

.ensure {
  position: relative;

  img {
    width: 100%;
  }

  .purple_text {
    position: absolute;
    width: 120%;
    height: 325px;
    background: #4559E9;
    left: -150px;
    top: 170px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;

    .step {
      width: 960px;
      margin: 0 auto;

      &:nth-child(1) {
        margin-top: 96px;
      }
    }
  }
}

.background {
  background: #FAFBFF;
  padding: 110px 0 40px;
}

::v-deep .el-input__inner {
  background: #EEF2FC;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #046FFF;
  border-radius: 18px;
  height: 50px;
  width: 376px;
  padding-right: 45px;

  &::placeholder {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #046FFF;
  }
}

::v-deep .el-input__suffix {
  right: 15px;
}

::v-deep .el-select-dropdown__item {
  color: #fff;
}

::v-deep .el-scrollbar,
::v-deep .el-select-dropdown {
  background-color: transparent !important;
  color: #fff !important;
}

::v-deep .el-scrollbar__wrap,
::v-deep .el-select-dropdown__list {
  background-color: #046FFF;
  color: #fff !important;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #046FFF;
  color: #fff;
}

::v-deep .el-icon-arrow-up:before {
  content: '\e790';
  font-size: 30px;
  color: #6196FF;
}

@media (max-width: 1200px) {

  .classify_title,
  .classify_lists,
  .ways,
  .solutions {
    width: 90% !important;
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {

  .classify_title,
  .classify_lists,
  .ways,
  .solutions {
    width: 85% !important;
  }

  .introduce .content_A {
    font-size: 20px;
  }

  .classify_lists .classify_pic .circle {
    top: 144px;
  }

  .ways {
    flex-wrap: nowrap;
  }

  .ways .hasImg .imgContent {
    font-size: 37px;
    top: 50px;
  }

  .banner .banner_Title .subtitle {
    font-size: 20px;
  }

  .banner {
    height: 400px !important;
  }

  .banner .banner_Title .title {
    width: 100%;
    font-size: 37px;
  }

  .measures .measure .text {
    font-size: 16px;
  }

  .ensure .purple_text {
    width: 110%;
    left: -54px;
  }

  .measures .measure .round {
    width: 240px;
    height: 240px;
    left: calc(50% - 120px);
    line-height: 240px;
  }

  .classify_lists .classify_pic img {
    margin-bottom: 100px;
  }
  .solutions > .solution > .solution_title{
    font-size: 30px;
  }
  .solutions > .solution > .solution_text{
    font-size: 15px;
    line-height: 30px;
  }
  .content_s .top_list .number_title,
  .ensure .purple_text{
    font-size: 20px;
  }

}

@media screen and (min-width: 1350px) and (max-width: 1440px) {

  .classify_title,
  .classify_lists,
  .ways,
  .solutions {
    width: 80% !important;
  }
  .solutions > .solution > .solution_title{
    font-size: 30px;
  }
   .solutions > .solution > .solution_text{
    font-size: 15px;
        line-height: 30px;
  }
  .content_s .top_list .number_title,
  .ensure .purple_text {
    font-size: 22px;
  }

  .classify_lists .classify_pic .circle {
    top: 144px;
  }

  .banner .banner_Title .title {
    width: 95%;
    font-size: 40px;
  }

  .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .banner {
    height: 450px !important;
  }

  .ways {
    flex-wrap: nowrap;
  }

  .ensure .purple_text {
    width: 110%;
    left: -55px;
  }

  .measures .measure .text {
    font-size: 17px;
  }

  .measures .measure .title {
    margin: 80px 0 60px;
  }

  .measures .measure .round {
    width: 240px;
    height: 240px;
    left: calc(50% - 120px);
    line-height: 240px;
  }

  .ways .hasImg .imgContent {
    top: 56px;
    font-size: 35px;
  }

  .classify_lists .classify_pic img {
    margin-bottom: 90px;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1500px) {
  .ways .hasImg .imgContent {
    top: 75px;
    font-size: 35px;
  }

  .banner .banner_Title .title {
    font-size: 40px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 27px;
  }

}

@media screen and (min-width: 1500px) and (max-width: 1700px) {

  .classify_title,
  .classify_lists,
  .ways,
  .solutions {
    width: 75% !important;
  }

  .banner .banner_Title .subtitle {
    font-size: 30px;
  }

  .banner .banner_Title .title {
    font-size: 52px;
  }

  .ways {
    flex-wrap: wrap;
  }

  .ensure .purple_text {
    left: -110px;
  }

  .measures .measure .title {
    margin: 80px 0 60px;
  }
}
</style>
